import type { FC } from "react";

import styles from "./Tier.module.scss";

export type TierProps = {
  name: string;
  description: string;
  asset: string;
  altText: string;
  id?: number;
  dataTestId?: string;
};

export const Tier: FC<TierProps> = ({ name, description, asset, id, altText, dataTestId }) => {
  return (
    <div data-testid={dataTestId} className={styles.tier} data-tierid={id}>
      <div className={styles.wrapper}>
        <div className={styles.name}>{name}</div>
        <div className={styles.description}>{description}</div>
        <img alt={altText} className={styles.image} src={asset} />
      </div>
    </div>
  );
};
